import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["component", "theme"];

/* stylelint-disable no-descending-specificity */
import React, { useContext } from 'react';
import { KeyboardDetectionContext } from "../../contexts/KeyboardDetectionContext";
import { deprecatedPropWarning } from "../../deprecationWarnings";
import { Link } from "./Link";
export var PopoverNavigationLink = function PopoverNavigationLink(_ref) {
  var _ref$component = _ref.component,
      component = _ref$component === void 0 ? 'a' : _ref$component,
      theme = _ref.theme,
      props = _objectWithoutProperties(_ref, _excluded);

  if (theme) {
    deprecatedPropWarning('theme', 'This component is intended to inherit its parent’s color set or color.');
  }

  var _useContext = useContext(KeyboardDetectionContext),
      isUsingKeyboard = _useContext.isUsingKeyboard;

  return /*#__PURE__*/React.createElement(Link, Object.assign({
    component: component,
    isUsingKeyboard: isUsingKeyboard
  }, props));
};
/**
* **PopoverNavigationLink** ![Status: Production](https://img.shields.io/badge/PRODUCTION-%2357B560|height=14)
*
* [GitHub](https://ghe.spotify.net/encore/web/tree/master/src/core/components/PopoverNavigationLink) | [Storybook](https://encore-web.spotify.net/?path=/docs/components-popover-popovernavigationlink--default) | [Encore](https://encore.spotify.net/web/components/popover?format=figma-figma#popovernavigation) | [Figma](https://www.figma.com/file/bnQXqGkLeiTlbk8JXGDcsX/Encore-Web---Light-Theme-Toolkit?node-id=7907:6134) |
*
* PopoverNavigationLinks are links in the PopoverNaviagationList
*
* @example
* () => <PopoverNavigationLink href="#">Anchor link</PopoverNavigationLink>;
*
*/

export default PopoverNavigationLink;